module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGde11b15f3396bb06a9e8f63a8fa4dff0.de11b15f.png";